import React, { FC, useEffect } from 'react';
import { useHistory } from 'react-router';
import { NotificationsHash } from 'components/organisms/notifications/drawer/transformer';

export const Notifications: FC = () => {
  const { push } = useHistory();

  useEffect(() => {
    push({
      pathname: '/',
      hash: NotificationsHash,
    });
  }, [push]);

  return <div />;
};
